import { Controller } from "@hotwired/stimulus"
import { toggle, leave } from "el-transition"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = [ "mobileMenu", "desktopMenu" ]

  toggleDesktopMenu() {
    toggle(this.desktopMenuTarget)
  }

  toggleMobileMenu() {
    toggle(this.mobileMenuTarget)
  }

  closeDesktopMenu(event) {
    if (!this.element.contains(event.target)) {
      leave(this.desktopMenuTarget)
    }
  }

  closeMobileMenu(event) {
    if (!this.element.contains(event.target)) {
      leave(this.mobileMenuTarget)
    }
  }
}
